import { z } from 'zod';

export const estimatesSchema = z.object({
  costAndTime: z.boolean(),
});
